import { useNavigate } from "react-router-dom";
import { CalendarPlus, Car, FileText, Package, Plus, Receipt, UserPlus, Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useGarage } from "@/context/GarageContext";
import { t } from "@/i18n";

export function useNewItems() {
  const { hasFeature, isManager, readOnly, canManage } = useGarage();
  if (readOnly) return [];
  const billing = hasFeature("quotes_and_invoices");
  return [
    { key: "appointment", to: "/pro/planning", icon: CalendarPlus },
    { key: "customer", to: "/pro/customers", icon: UserPlus },
    { key: "vehicle", to: "/pro/vehicles", icon: Car },
    { key: "job", to: "/pro/jobs", icon: Wrench },
    ...(billing && isManager ? [{ key: "quote", to: "/pro/quotes", icon: FileText }, { key: "invoice", to: "/pro/invoices", icon: Receipt }] : []),
    ...(hasFeature("inventory") && canManage ? [{ key: "part", to: "/pro/inventory?tab=parts", icon: Package }] : []),
  ];
}

export function NewMenu({ fab }) {
  const items = useNewItems();
  const navigate = useNavigate();
  if (!items.length) return null;
  const go = (to) => navigate(`${to}${to.includes("?") ? "&" : "?"}new=1&n=${Date.now()}`);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {fab ? <button type="button" aria-label={t("b13.new")} data-testid="fab-new" className="grid h-14 w-14 place-items-center rounded-full bg-teal-600 text-white shadow-lg shadow-teal-900/30 transition-transform duration-150 active:scale-95"><Plus className="h-6 w-6" /></button>
          : <Button className="bg-teal-600 hover:bg-teal-700" data-testid="topbar-new"><Plus className="mr-1.5 h-4 w-4" />{t("b13.new")}</Button>}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuLabel>{t("b13.create")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {items.map(({ key, to, icon: Icon }) => (
          <DropdownMenuItem key={key} onSelect={() => go(to)} className="min-h-10" data-testid={`new-menu-${key}`}><Icon className="mr-2 h-4 w-4 text-slate-500" />{t(`b13.newItems.${key}`)}</DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
